import type { FieldMarkerTask } from '../../domain/fieldMarkerTask'
import type { MarkerTask, MarkerTaskHistoryEntry } from '../../domain/markerTask'

export const markersFixtures: MarkerTask[] = [
  {
    taskId: 'f0000000-0000-4000-a000-000000000001',
    contractId: 'f1000000-0000-4000-a000-000000000001',
    contractNumber: 'CTR-000000',
    serviceLocationId: 'f2000000-0000-4000-a000-000000000001',
    addressLine1: '4100 Rue Talon',
    addressLine2: null,
    city: 'Saint-Jérôme',
    status: 'PENDING',
    clientName: 'Hélène Gagnon',
    clientPhone: '(450) 555-0101',
    clientEmail: 'helene.gagnon@example.com',
    billingAddress: '88 Rue Principale, Saint-Sauveur, J0R 1R0',
  },
  {
    taskId: 'f0000000-0000-4000-a000-000000000002',
    contractId: 'f1000000-0000-4000-a000-000000000001',
    contractNumber: 'CTR-000000',
    serviceLocationId: 'f2000000-0000-4000-a000-000000000002',
    addressLine1: '4235 Rue Talon',
    addressLine2: 'Unité 2',
    city: 'Saint-Jérôme',
    status: 'PENDING',
    clientName: 'Hélène Gagnon',
    clientPhone: '(450) 555-0101',
    clientEmail: 'helene.gagnon@example.com',
    billingAddress: '88 Rue Principale, Saint-Sauveur, J0R 1R0',
  },
  {
    taskId: 'f0000000-0000-4000-a000-000000000003',
    contractId: 'f1000000-0000-4000-a000-000000000002',
    contractNumber: 'CTR-000041',
    serviceLocationId: 'f2000000-0000-4000-a000-000000000003',
    addressLine1: '15 Boulevard des Laurentides',
    addressLine2: null,
    city: 'Saint-Jérôme',
    status: 'PENDING',
    clientName: 'Marcel Tremblay',
    clientPhone: '450-555-0202',
    clientEmail: 'marcel.tremblay@example.com',
  },
]

export const markersHistoryFixtures: MarkerTaskHistoryEntry[] = [
  {
    taskId: 'f0000000-0000-4000-a000-000000000004',
    contractId: 'f1000000-0000-4000-a000-000000000003',
    contractNumber: 'CTR-000052',
    serviceLocationId: 'f2000000-0000-4000-a000-000000000004',
    addressLine1: '700 Rue Talon',
    addressLine2: null,
    city: 'Saint-Jérôme',
    status: 'INSTALLED',
    completedAt: '2026-09-29T15:04:00.000Z',
  },
  {
    taskId: 'f0000000-0000-4000-a000-000000000005',
    contractId: 'f1000000-0000-4000-a000-000000000003',
    contractNumber: 'CTR-000052',
    serviceLocationId: 'f2000000-0000-4000-a000-000000000005',
    addressLine1: '35 Boulevard des Laurentides',
    addressLine2: null,
    city: 'Saint-Jérôme',
    status: 'CANCELLED',
    completedAt: '2026-09-28T10:30:00.000Z',
  },
]

/** Données fictives pour l'interface terrain (aucun vrai client). */
export const fieldMarkersFixtures: FieldMarkerTask[] = [
  {
    taskId: 'f3000000-0000-4000-a000-000000000001',
    addressLine1: '412 Rue des Érables',
    addressLine2: null,
    city: 'Saint-Jérôme',
    postalCode: 'J7Z 1A1',
    clientName: 'Marie Tremblay',
    phone: '(450) 555-0142',
    latitude: 45.7805,
    longitude: -74.0021,
    instructions: 'Entrée de gauche, balise côté boîte aux lettres.',
    lastAttemptAt: null,
    lastAttemptReason: null,
  },
  {
    taskId: 'f3000000-0000-4000-a000-000000000002',
    addressLine1: '418 Rue des Érables',
    addressLine2: null,
    city: 'Saint-Jérôme',
    postalCode: 'J7Z 1A1',
    clientName: 'Luc Gagnon',
    phone: '(450) 555-0177',
    latitude: 45.7807,
    longitude: -74.0017,
    instructions: null,
    lastAttemptAt: '2026-10-07T14:20:00.000Z',
    lastAttemptReason: 'Véhicule dans l’entrée, impossible de poser les balises.',
  },
  {
    taskId: 'f3000000-0000-4000-a000-000000000003',
    addressLine1: '1207 Boulevard des Laurentides',
    addressLine2: 'Unité 1207-B',
    city: 'Saint-Jérôme',
    postalCode: 'J7Z 4M6',
    clientName: 'Société de gestion immobilière des Laurentides inc.',
    phone: null,
    latitude: 45.7712,
    longitude: -74.0105,
    instructions: 'Accès par le stationnement arrière.',
    lastAttemptAt: null,
    lastAttemptReason: null,
  },
  {
    taskId: 'f3000000-0000-4000-a000-000000000004',
    addressLine1: '88 Rue du Lac-Inconnu',
    addressLine2: null,
    city: 'Saint-Jérôme',
    postalCode: null,
    clientName: 'Hélène Gagnon',
    phone: '450 555 0101',
    latitude: null,
    longitude: null,
    instructions: null,
    lastAttemptAt: null,
    lastAttemptReason: null,
  },
]
